import React from 'react';
import './App.css';
import KeywordManagementPane from './components/KeywordManagementPane';
import FolderHierarchyPane from './components/FolderHierarchyPane';
import { DndProvider } from 'react-dnd';
import { HTML5Backend } from 'react-dnd-html5-backend';

function App() {
  return (
    <DndProvider backend={HTML5Backend}>
      <div className="app-container">
        <div className="keyword-pane">
          <KeywordManagementPane />
        </div>
        <div className="folder-pane">
          <FolderHierarchyPane />
        </div>
      </div>
    </DndProvider>
  );
}

export default App;
